import 'react';
import ClassNames from 'classnames';
import { Typography, Action, getImageVariation, EshopsComponentsTitles } from '@mshops-components-library/common';
import { Image } from 'frontend-image';
import { Button } from '@andes/button';
var REACT_ELEMENT_TYPE;
function _createRawReactElement(e, r, E, l) {
  REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol["for"] && Symbol["for"]("react.element") || 60103);
  var o = e && e.defaultProps,
    n = arguments.length - 3;
  if (r || 0 === n || (r = {
    children: void 0
  }), 1 === n) r.children = l;else if (n > 1) {
    for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];
    r.children = t;
  }
  if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});
  return {
    $$typeof: REACT_ELEMENT_TYPE,
    type: e,
    key: void 0 === E ? null : "" + E,
    ref: null,
    props: r,
    _owner: null
  };
}
var VALID_ESHOP_TYPES = ['seller', 'affiliate', 'brand'];
var typeEshop = function typeEshop(eshopType) {
  return Boolean(eshopType && VALID_ESHOP_TYPES.includes(eshopType));
};
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _defineProperty(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
var EMPTY_PATH = '/storage/mshops-appearance-api/resources/empty_state/';
var replaceExtension = function replaceExtension(url) {
  var regex = /(\.(?!svg|webp$)[a-zA-Z0-9]+)$/i;
  return url === null || url === void 0 ? void 0 : url.replace(regex, '.webp');
};
var ContentSlide = function ContentSlide(_ref) {
  var button = _ref.button,
    description = _ref.description,
    deviceType = _ref.deviceType,
    elementTitle = _ref.elementTitle,
    image = _ref.image,
    lazyLoad = _ref.lazyLoad,
    customStyles = _ref.customStyles,
    align = _ref.align,
    maxImageSize = _ref.maxImageSize;
  var isDesktop = deviceType === 'desktop';
  var imageSrc = isDesktop ? image.desktop : image.mobile;
  var design = customStyles.design,
    buttonDesign = customStyles.button_design;
  var imageClass = ClassNames('content-element__image', _defineProperty(_defineProperty({}, "content-element__image--".concat(design), design), 'content-element__image--cover', imageSrc.includes(EMPTY_PATH)));
  var textContainerClass = ClassNames('content-element__container-text', {
    'content-element__container-text--hidden': elementTitle.hidden && description.hidden && button.hidden,
    'content-element__container-text--full-width': image.hidden
  });
  var renderTitle = function renderTitle() {
    return /*#__PURE__*/_createRawReactElement(Typography, {
      variant: "h4",
      className: "content-element__title",
      type: "title",
      size: isDesktop ? 'small' : 'xsmall',
      weight: "bold"
    }, void 0, elementTitle.text);
  };
  var renderDescription = function renderDescription() {
    return /*#__PURE__*/_createRawReactElement(Typography, {
      variant: "body",
      className: "content-element__description",
      size: "medium"
    }, void 0, description.text);
  };
  var renderButtonAction = function renderButtonAction() {
    return /*#__PURE__*/_createRawReactElement(Action, {
      className: "content-element__button-container",
      target: button.button_href,
      isSelf: true
    }, void 0, /*#__PURE__*/_createRawReactElement("p", {
      className: "content-element__button-text"
    }, void 0, button.button_text));
  };
  var renderButton = function renderButton() {
    return /*#__PURE__*/_createRawReactElement(Button, {
      hierarchy: "quiet",
      size: isDesktop ? 'large' : 'medium',
      href: button.button_href
    }, void 0, button.button_text);
  };
  return /*#__PURE__*/_createRawReactElement("div", {
    className: "content-element content-element--align-".concat(align)
  }, void 0, !image.hidden && /*#__PURE__*/_createRawReactElement("div", {
    className: "content-element__img-container"
  }, void 0, /*#__PURE__*/_createRawReactElement(Image, {
    className: imageClass,
    src: getImageVariation(maxImageSize, replaceExtension(imageSrc)),
    alt: elementTitle.text,
    lazyload: lazyLoad
  })), /*#__PURE__*/_createRawReactElement("div", {
    className: textContainerClass
  }, void 0, !elementTitle.hidden && renderTitle(), !description.hidden && renderDescription(), !button.hidden && (buttonDesign === 'link-text' ? renderButtonAction() : /*#__PURE__*/_createRawReactElement("div", {
    className: "content-element__button-container"
  }, void 0, renderButton()))));
};
ContentSlide.defaultProps = {
  button: null,
  description: null,
  elementTitle: null,
  image: {
    desktop: '',
    hidden: false,
    mobile: ''
  },
  lazyLoad: 'on'
};
var ContentSlide$1 = ContentSlide;
var MAX_IMAGE_SIZE_BY_THEME_AND_DEVICE = {
  "default": {
    mobile: 328,
    desktop: {
      2: 584,
      3: 378,
      4: 276
    }
  },
  legend: {
    mobile: 426,
    desktop: {
      2: 592,
      3: 518,
      4: 384
    }
  },
  explorer: {
    mobile: 320,
    desktop: 720
  }
};
var getMaxImageSize = function getMaxImageSize(theme, device, elementsCount) {
  var MAX_IMAGE_SIZE_BY_DEVICE = MAX_IMAGE_SIZE_BY_THEME_AND_DEVICE[theme] || MAX_IMAGE_SIZE_BY_THEME_AND_DEVICE["default"];
  if (device === 'mobile') {
    return MAX_IMAGE_SIZE_BY_DEVICE.mobile;
  }
  if (typeof MAX_IMAGE_SIZE_BY_DEVICE.desktop === 'number') {
    return MAX_IMAGE_SIZE_BY_DEVICE.desktop;
  }
  return MAX_IMAGE_SIZE_BY_DEVICE.desktop[elementsCount] || 720;
};
var getMaxImageSize$1 = getMaxImageSize;
var ContentList = function ContentList(_ref) {
  var _EshopsComponentsTitl;
  var deviceType = _ref.deviceType,
    elements = _ref.elements,
    title = _ref.title,
    titleEnabled = _ref.titleEnabled,
    eshopType = _ref.eshopType,
    lazyLoading = _ref.lazyLoading,
    _ref$custom_styles = _ref.custom_styles,
    customStyles = _ref$custom_styles === void 0 ? {
      design: 'standard'
    } : _ref$custom_styles,
    _ref$text_alignment = _ref.text_alignment,
    textAlignment = _ref$text_alignment === void 0 ? 'left' : _ref$text_alignment,
    layoutTheme = _ref.layoutTheme;
  var design = customStyles.design;
  var isDesktop = deviceType === 'desktop';
  var containerClasses = ClassNames('content-list__container', "content-list__container--".concat(design));
  var containerElementsClasses = ClassNames('content-list__elements-container', "content-list__".concat(elements.length, "-elements"));
  var titleContentListClasses = ClassNames('content-list__title', "content-list__title--".concat(textAlignment));
  var renderElementTitle = function renderElementTitle() {
    return /*#__PURE__*/_createRawReactElement(Typography, {
      variant: "h5",
      className: titleContentListClasses,
      type: "title",
      size: isDesktop ? 'medium' : 'small',
      weight: "bold"
    }, void 0, title);
  };
  var showTitles = function showTitles() {
    return typeEshop(eshopType) ? _EshopsComponentsTitl || (_EshopsComponentsTitl = /*#__PURE__*/_createRawReactElement(EshopsComponentsTitles, {
      title: title,
      showTitle: titleEnabled,
      deviceType: deviceType,
      titleClassName: titleContentListClasses,
      subtitleClassName: titleContentListClasses
    })) : renderElementTitle();
  };
  var maxImageSize = getMaxImageSize$1(layoutTheme, deviceType, elements.length);
  return /*#__PURE__*/_createRawReactElement("div", {
    className: containerClasses
  }, void 0, /*#__PURE__*/_createRawReactElement("div", {
    className: "content-list__element content-list__container__".concat(elements.length, "-elements")
  }, void 0, showTitles(), /*#__PURE__*/_createRawReactElement("div", {
    className: containerElementsClasses
  }, void 0, elements.map(function (element, index) {
    return /*#__PURE__*/_createRawReactElement(ContentSlide$1, {
      align: element.align,
      button: element.button,
      description: element.description,
      deviceType: deviceType,
      elementTitle: element.element_title,
      image: element.image,
      lazyLoad: lazyLoading,
      customStyles: customStyles,
      layoutTheme: layoutTheme,
      maxImageSize: maxImageSize
    }, index.toString());
  }))));
};
ContentList.defaultProps = {
  titleEnabled: true,
  lazyLoading: 'on'
};
var ContentList$1 = ContentList;
export { ContentList$1 as ContentList, ContentList$1 as default };
